import { OSId } from '@ps/platform-message-framework/common/OSId';
import type { DeviceBasedContent } from '@ps/web-martech-cms-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSReference } from '@swf/cms';
import { select } from '@swf/core/store';

const CMSDeviceBasedContent: React.FC<DeviceBasedContent> = ({ body, rules }) => {
  const isMobile = useSelector(select.device.isMobile);
  const isAndroid = useSelector(select.device.isAndroid);
  const isIos = useSelector(select.device.getOS) === OSId.I_OS;
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isDesktopWeb = useSelector(select.device.isDesktopWeb);

  const device = rules[0]?.device_rule.device;
  const operator = rules[0]?.device_rule.operator;
  if (!device || !operator) return null;

  const mobileCond =
    device === 'mobile' && ((operator === '=' && isMobile) || (operator === '!=' && !isMobile));

  const androidCond =
    device === 'android' && ((operator === '=' && isAndroid) || (operator === '!=' && !isAndroid));

  const iosCond =
    device === 'ios' && ((operator === '=' && isIos) || (operator === '!=' && !isIos));

  const desktopClientCond =
    device === 'desktop client' &&
    ((operator === '=' && isDesktopEmbedded) || (operator === '!=' && !isDesktopEmbedded));

  const desktopWebCond =
    device === 'desktop web' &&
    ((operator === '=' && isDesktopWeb) || (operator === '!=' && !isDesktopWeb));

  if (mobileCond || androidCond || iosCond || desktopClientCond || desktopWebCond) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {body.map((item, i) => (
          <CMSReference key={i} {...item} />
        ))}
      </>
    );
  }

  return null;
};

export default CMSDeviceBasedContent;
